import type { MotifJustification } from '../../lib/useAbsences';

const CLASSE_CHAMP =
  'w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm text-codialis-navy focus:border-codialis-sky focus:outline-none';
const CLASSE_LIBELLE = 'mb-1 block text-[11px] font-bold uppercase tracking-wider text-codialis-gray';

/**
 * Motif de justification et sa précision, communs au pôle et à l'apprenant.
 * La liste vient de l'API (`referentiels/absences.ts`) ; « Autre motif » exige
 * une précision — l'API le refuse aussi.
 */
export function ChoixMotif({
  motifs,
  motif,
  precision,
  onMotif,
  onPrecision,
  prefixe,
}: {
  motifs: MotifJustification[];
  motif: string;
  precision: string;
  onMotif: (code: string) => void;
  onPrecision: (texte: string) => void;
  /** Préfixe des identifiants, pour deux formulaires sur une même page. */
  prefixe: string;
}): JSX.Element {
  const choisi = motifs.find((candidat) => candidat.code === motif);
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div className="min-w-0">
        <label htmlFor={`${prefixe}-motif`} className={CLASSE_LIBELLE}>
          Motif
        </label>
        <select
          id={`${prefixe}-motif`}
          value={motif}
          onChange={(evenement) => onMotif(evenement.target.value)}
          className={CLASSE_CHAMP}
        >
          <option value="">Choisir un motif</option>
          {motifs.map((candidat) => (
            <option key={candidat.code} value={candidat.code}>
              {candidat.libelle}
            </option>
          ))}
        </select>
      </div>
      <div className="min-w-0">
        <label htmlFor={`${prefixe}-precision`} className={CLASSE_LIBELLE}>
          Précision{choisi?.precisionExigee ? '' : ' (facultative)'}
        </label>
        <input
          id={`${prefixe}-precision`}
          value={precision}
          onChange={(evenement) => onPrecision(evenement.target.value)}
          maxLength={300}
          className={CLASSE_CHAMP}
          placeholder={choisi?.precisionExigee ? 'Exigée pour ce motif' : 'Ex. arrêt du 12 au 14'}
        />
      </div>
    </div>
  );
}

/** Le motif est-il complet ? Même règle que l'API, pour griser le bouton. */
export function motifComplet(motifs: MotifJustification[], motif: string, precision: string): boolean {
  const choisi = motifs.find((candidat) => candidat.code === motif);
  if (!choisi) return false;
  return !choisi.precisionExigee || precision.trim().length > 0;
}
